// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1swHb","left":"styles_left__24xCA","desktopActions":"styles_desktopActions__3ToiD","title":"styles_title__1ZN-u"};